import React, { ComponentProps } from 'react';

import { Icon } from '@zapier/zinnia-icons';
import { Button } from '@zapier/design-system';
import { DropdownMenu } from '@zapier/common-components';

import type { SemVer } from 'app/developer-v3/types/version';

type Props = {
  chosenLabel: string;
  onChange: (value: SemVer) => void;
  size?: ComponentProps<typeof Button>['size'];
  version: SemVer;
  versions: SemVer[];
};

function VersionDropdown({
  chosenLabel,
  onChange,
  size,
  version,
  versions,
}: Props) {
  return (
    <DropdownMenu
      children={null}
      items={versions.map(v => ({ label: v, value: v }))}
      menuIsBlock={true}
      onSelect={({ value }) => onChange(value)}
      showDividers={true}
      ToggleComponent={toggleProps => (
        <Button
          {...toggleProps}
          size={size}
          iconPosition="start"
          onPress={event => {
            // DropdownMenu renders a wrapper around the ToggleComponent. That wrapper handles the click event. We need to continue the propagation to let that wrapper receive the event in order to open/close the menu.
            event.continuePropagation();
          }}
        >
          <Icon name="arrowSmallDown" />

          {`${chosenLabel || 'Viewing'} ${version}`}
        </Button>
      )}
    />
  );
}

export default VersionDropdown;
